module.exports = __webpack_public_path__ + "static/media/joey_english_us.30a26b78.mp3";